module.exports = __webpack_public_path__ + "img/redbg_front@2x.ecc43b53.png";